import { Button, Input, Label } from '@design-system';

export type RequestsFilterDraft = {
  search: string;
  status: string;
  createdFrom: string;
  createdTo: string;
};

interface RequestsFiltersProps {
  value: RequestsFilterDraft;
  onChange: (next: RequestsFilterDraft) => void;
  onApply: () => void;
  onClear: () => void;
  isFetching: boolean;
}

const STATUSES = ['initiated', 'queued', 'processing', 'completed', 'error'];

const selectClass =
  'w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary';

export function RequestsFilters({
  value,
  onChange,
  onApply,
  onClear,
  isFetching,
}: RequestsFiltersProps) {
  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-5">
      <div className="md:col-span-2">
        <Label className="mb-1 block text-xs font-semibold text-gray-600">Search</Label>
        <Input
          placeholder="request id, quote id, or client id"
          value={value.search}
          onChange={e => onChange({ ...value, search: e.target.value })}
          onKeyDown={e => {
            if (e.key === 'Enter') onApply();
          }}
        />
      </div>
      <div>
        <Label className="mb-1 block text-xs font-semibold text-gray-600">Status</Label>
        <select
          className={selectClass}
          value={value.status}
          onChange={e => onChange({ ...value, status: e.target.value })}
        >
          <option value="">Any</option>
          {STATUSES.map(s => (
            <option key={s} value={s}>
              {s}
            </option>
          ))}
        </select>
      </div>
      <div>
        <Label className="mb-1 block text-xs font-semibold text-gray-600">Created from</Label>
        <Input
          type="date"
          value={value.createdFrom}
          onChange={e => onChange({ ...value, createdFrom: e.target.value })}
        />
      </div>
      <div>
        <Label className="mb-1 block text-xs font-semibold text-gray-600">Created to</Label>
        <Input
          type="date"
          value={value.createdTo}
          onChange={e => onChange({ ...value, createdTo: e.target.value })}
        />
      </div>
      <div className="flex items-end gap-2 md:col-span-5">
        <Button onClick={onApply} disabled={isFetching}>
          {isFetching ? 'Loading...' : 'Apply'}
        </Button>
        <Button variant="outline" onClick={onClear}>
          Clear
        </Button>
      </div>
    </div>
  );
}
